import React from 'react';

/**
 * JR Logo Component (Icon only, no text)
 * JR字母组合，R的斜腿设计成向上箭头
 */
export default function JRLogo({ size = 50, color = '#1e40af' }: { size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size * 0.8}
      viewBox="0 0 120 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* J letter - left vertical stroke with curve */}
      <path
        d="M 15 15 L 15 75 Q 15 85 25 85 L 35 85"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* R letter - vertical stem (shared with J) */}
      <path
        d="M 35 15 L 35 50"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* R letter - top horizontal and curve */}
      <path
        d="M 35 15 L 60 15 Q 70 15 70 25 Q 70 35 60 35 L 35 35"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Arrow (R's diagonal leg as upward arrow) */}
      <path
        d="M 35 50 L 95 10"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Arrow head */}
      <path
        d="M 88 5 L 95 10 L 88 15"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

